import React from 'react';
import { Config } from '@leverege/plugin';
import VideoStreamRenderer from "./VideoStreamRenderer.js";
const videoStreamViewerOpts = {
  table: {
    isRenderer: true,
    embed: true
  },
  detail: {
    isRenderer: true,
    embed: true
  }
};
export default {
  id: 'ui-video.processors.VideoStreamBlueprintsProcessor',
  processBlueprints(molten, blueprints) {
    blueprints.forEach(bp => {
      bp.attributes.forEach(attr => {
        if (attr.hasTag('is:port:rtsp')) {
          molten.addPlugin('AttributeValueEditor', {
            valueType: attr.valueType,
            name: `${bp.type}.${attr.path.replace(/\//g, '.')}`,
            getOptions: usage => {
              return Config.get('VideoStreamRenderer', usage, videoStreamViewerOpts[usage]);
            },
            create: opts => {
              return /*#__PURE__*/React.createElement(VideoStreamRenderer, {
                ...opts,
                variant: 'link'
              });
            }
          });
        }
      });
    });
  }
};